module.exports = __webpack_public_path__ + "static/img/14.5d9b84a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/sp/14.png
// module id = TXqk
// module chunks = 0